import { motion } from "framer-motion";

export function MatchCard({ match, index, tip, onChange, disabled, opponentName }) {
  const num = String(index + 1).padStart(2, "0");
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, delay: (index % 4) * 0.05 }}
      className="glass rounded-2xl p-5 sm:p-6"
      data-testid={`match-card-${index}`}
    >
      <div className="flex items-center justify-between mb-4">
        <span className="font-head text-4xl leading-none text-white/15">{num}</span>
        <span className="text-xs tracking-[0.1em] uppercase text-[#cbd5e1] font-semibold">
          {match.kickoff}
        </span>
      </div>

      <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-3">
        <div className="text-right">
          <p className="font-head text-lg sm:text-xl leading-tight uppercase text-white" data-testid={`home-${index}`}>
            {match.home}
          </p>
          <p className="text-xs tracking-widest uppercase text-[#cbd5e1] mt-1">Heim</p>
        </div>

        <div className="flex flex-col items-center gap-2 px-1">
          <div className="flex items-center gap-2">
            <input
              type="number"
              min="0"
              max="99"
              inputMode="numeric"
              placeholder="–"
              disabled={disabled}
              id={`sc-${index}-home`}
              value={tip?.home ?? ""}
              onFocus={(e) => e.target.select()}
              onChange={(e) => {
                onChange(match.id, "home", e.target.value);
                if (e.target.value !== "") document.getElementById(`sc-${index}-away`)?.focus();
              }}
              className="score-input !w-14 disabled:opacity-40"
              data-testid={`tip-home-${index}`}
              aria-label={`Tipp Heim ${match.home}`}
            />
            <span className="font-head text-2xl text-[#e9b44c]">:</span>
            <input
              type="number"
              min="0"
              max="99"
              inputMode="numeric"
              placeholder="–"
              disabled={disabled}
              id={`sc-${index}-away`}
              value={tip?.away ?? ""}
              onFocus={(e) => e.target.select()}
              onChange={(e) => {
                onChange(match.id, "away", e.target.value);
                if (e.target.value !== "") {
                  const next = document.getElementById(`sc-${index + 1}-home`);
                  if (next) next.focus();
                  else e.target.blur();
                }
              }}
              className="score-input !w-14 disabled:opacity-40"
              data-testid={`tip-away-${index}`}
              aria-label={`Tipp Gast ${match.away}`}
            />
          </div>
        </div>

        <div className="text-left">
          <p className="font-head text-lg sm:text-xl leading-tight uppercase text-white" data-testid={`away-${index}`}>
            {match.away}
          </p>
          <p className="text-xs tracking-widest uppercase text-[#cbd5e1] mt-1">Gast</p>
        </div>
      </div>

      <div className="mt-4 flex items-center justify-center">
        <span
          className="inline-flex items-center gap-2.5 rounded-full border border-[#e9b44c]/40 bg-[#e9b44c]/10 px-4 py-2"
          data-testid={`trainer-tip-${index}`}
        >
          <span className="text-sm tracking-[0.08em] uppercase text-[#e9b44c] font-bold">
            {opponentName || "Trainer"}
          </span>
          <span className="font-head text-xl text-white">
            {match.trainer_home ?? "–"} : {match.trainer_away ?? "–"}
          </span>
        </span>
      </div>
    </motion.div>
  );
}
